import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import StorageIcon from '@mui/icons-material/Storage';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import MemoryIcon from '@mui/icons-material/Memory';
import ComputerIcon from '@mui/icons-material/Computer';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../contexts/ContentContext';

const iconMap = {
  repair: BuildIcon,
  dataRecovery: StorageIcon,
  performance: SpeedIcon,
  virus: SecurityIcon,
  customBuilds: MemoryIcon,
  diagnostics: ComputerIcon,
};

const Services = () => {
  const { language } = useLanguage();
  const { content } = useContent();
  const t = content[language] || content.ar;

  return (
    <Box sx={{ minHeight: 'calc(100vh - 200px)' }}>
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 6,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '1.8rem', sm: '2.5rem', md: '2.8rem' } }}>
            {t.servicesTitle}
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
            {t.servicesSubtitle}
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 8, bgcolor: '#fafafa' }}>
        <Container maxWidth="lg">
          <Grid container spacing={3} sx={{ width: '100%' }}>
            {t.services?.map((service, index) => {
              const IconComponent = iconMap[service.icon] || ComputerIcon;
              return (
                <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                  <Card
                    elevation={0}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      borderRadius: 2,
                      border: '1px solid #e0e0e0',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        transform: 'translateY(-4px)',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3, pb: 2, display: 'flex', flexDirection: 'column', flex: 1 }}>
                      <Box
                        sx={{
                          width: 64,
                          height: 64,
                          borderRadius: 1,
                          bgcolor: '#E8F5E9',
                          color: 'primary.main',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 2,
                          flexShrink: 0,
                        }}
                      >
                        <IconComponent sx={{ fontSize: 32 }} />
                      </Box>
                      <Typography
                        variant="h6"
                        component="h3"
                        gutterBottom
                        sx={{ fontWeight: 700, color: 'text.primary', fontSize: '1.1rem', mb: 1.5 }}
                      >
                        {service.title}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        color="text.secondary" 
                        sx={{ lineHeight: 1.6, flex: 1 }}
                      >
                        {service.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Services;
